<template>
  <div class="row">
    <card class="card">
      <p class="card-text">{{ title }}</p>
      <div v-if="imageUrls.length > 0" class="row">
        <div class="col-sm-1">{{ imageIndex + 1 }}/{{ imageUrls.length }}</div>
        <div class="col-sm-11">
          <img
            ref="img"
            id="img"
            slot="image"
            v-if="imageUrls.length > 0"
            @click="nextImage"
            class="card-img-top cover-img"
            v-bind:src="imageUrls[imageIndex]"
          />
          <iframe width="0" height="0" v-for="item in iframeUrl" v-bind:key="item" v-bind:src="item" style="display: none"></iframe>
        </div>
      </div>
      <p v-if="descriptions" class="card-text">{{ descriptions[imageIndex] }}</p>
    </card>
  </div>
</template>

<script>
import { Card } from "@/components/index";

export default {
  name: "SingleCardLayout",
  created() {},
  components: {
    Card,
  },
  props: {
    title: {
      required: false,
      type: String,
    },
    fileIds: {
      type: Array,
      required: false,
    },
    descriptions: {
      type: Array,
      required: false,
    },
    urls: {
      type: Array,
      required: false,
    },
  },
  watch: {
    fileIds: {
      handler() {
        if (this.fileIds) {
          this.imageUrls = [];
          for (let i = 0; i < this.fileIds.length; i++) {
            this.imageUrls.push(window.Endpoints.imageServerUrl + this.fileIds[i]);
          }
        }
      },
      immediate: true,
    },
    urls: {
      handler() {
        if (this.urls) {
          this.imageUrls = this.urls;
          for (let i = 0; i < this.urls.length; i++) {
            this.iframeUrl.push(`${window.Endpoints.iframeUrl}${encodeURIComponent(this.urls[i])}`);
          }
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      imageUrls: [],
      iframeUrl: [],
      imageIndex: 0,
    };
  },
  methods: {
    nextImage() {
      if (this.imageIndex + 1 < this.imageUrls.length) {
        this.imageIndex++;
      } else {
        this.imageIndex = 0;
      }
    },
  },
};
</script>
<style scoped>
.cover-img {
  height: 200px !important;
}
img {
  object-fit: contain;
  height: 100px;
  width: 200px;
  cursor: pointer;
}
</style>
